module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/~/core-js/library/modules/_add-to-unscopables.js
// module id = 192
// module chunks = 0